import { useEffect, useRef } from "react";

export const Oscilloscope = ({ engineRef, active }) => {
  const canvas = useRef(null);
  useEffect(() => {
    let raf;
    const draw = () => {
      const c = canvas.current;
      if (!c) return;
      const ctx = c.getContext("2d");
      const w = (c.width = c.offsetWidth);
      const h = (c.height = c.offsetHeight);
      ctx.clearRect(0, 0, w, h);
      ctx.strokeStyle = "rgba(0,229,255,0.85)";
      ctx.lineWidth = 1.5;
      ctx.shadowColor = "#00E5FF";
      ctx.shadowBlur = 8;
      ctx.beginPath();
      const an = engineRef.current?.analyser;
      if (an && active) {
        const data = new Uint8Array(an.fftSize);
        an.getByteTimeDomainData(data);
        for (let i = 0; i < data.length; i++) {
          const x = (i / data.length) * w;
          const y = (data[i] / 255) * h;
          i ? ctx.lineTo(x, y) : ctx.moveTo(x, y);
        }
      } else {
        ctx.moveTo(0, h / 2);
        ctx.lineTo(w, h / 2);
      }
      ctx.stroke();
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(raf);
  }, [engineRef, active]);
  return <canvas ref={canvas} className="w-full h-24 block" data-testid="oscilloscope" />;
};
